import { httpRequest, makeRequestURL } from 'common'

import { IEndpointsResponse, IGetPrivacyCenterEndpointsRequest } from '../types'
import { getPrivacyCenterEndpointsEndpoint } from '../utils'

const getPrivacyCenterEndpointsRemote = ({
  country,
  accountType,
  entity,
}: IGetPrivacyCenterEndpointsRequest) => {
  const url = makeRequestURL(
    getPrivacyCenterEndpointsEndpoint?.url ?? '',
    {
      country,
      accountType,
      entity,
    },
    '.json',
  )

  return httpRequest<IEndpointsResponse>(
    { ...getPrivacyCenterEndpointsEndpoint, url },
    { country, userType: accountType, entity },
  )
}

export { getPrivacyCenterEndpointsRemote }
